<div class="link-component {{type}}">
    <span [ngClass]="(isUnderlined)?'underline':''">{{labelText}}</span>
    <ng-container *ngIf="showIcons">
        <img *ngIf="navType === 'inbound'" src="../../../assets/svg/chevron.svg" alt="">
        <img *ngIf="navType === 'outbound'" src="../../../assets/svg/arrow-from-square.svg" alt="">
    </ng-container>
    
</div>